var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_vm._v(" © "),_c('a',{attrs:{"href":"https://webinnovations.ru/"}},[_vm._v("2021-2025 webinnovations.ru")])])
}]

export { render, staticRenderFns }